module.exports = __webpack_public_path__ + "static/media/bolso (39).620f5143.jpg";